<!-- START OF ADD TASK FORM -->
<form [formGroup]="frmTask" novalidate (ngSubmit)="onSubmitTask(frmTask.value)">
    <div class="modal-body">
        
            <div class="row pt-0">
                 <div class="col-md-4">
                     <div class="form-group">
                         <label>Title<span class="text-danger">*</span></label>
                         <input type="text" class="form-control form-control-sm" formControlName="title" required>
                         <div *ngIf="frmTask.controls.title.touched">
                            <div *ngIf="frmTask.controls.title.errors?.required">
                                <small class="text-danger" >This field is required.</small>
                            </div>
                        </div>
                     </div>
                 </div>
                 <div class="col-md-4">
                     <div class="form-group">
                         <label>Due Date:</label>
                         <input type="date" class="form-control form-control-sm" formControlName="date_due">
                     </div>
                 </div>
                 <div class="col-md-4">
                     <div class="form-group">
                         <label>Assigned To<span class="text-danger">*</span></label>
                         <select  class="form-control form-control-sm" placeholder="Select" formControlName="assigned_to" required> 
                             <option disabled selected *ngIf="isEditMode==false">Select..</option>
                             <option *ngFor="let user of users" value="{{user.id}}">{{user.display_name}}</option>
                         </select>
                         <div *ngIf="frmTask.controls.assigned_to.touched">
                            <div *ngIf="frmTask.controls.assigned_to.errors?.required">
                                <small class="text-danger" >This field is required.</small>
                            </div>
                        </div>
                     </div>
                 </div>
             </div>
             <div class="row pt-0" *ngIf="isEditMode==true">
                 <div class="col-md-4" >
                     <div class="form-group" >
                         <label>Status</label>
                         <select class="form-control form-control-sm" placeholder="Select" formControlName="status_id"> 
                             <option disabled selected>Select..</option>
                             <option *ngFor="let status of statuses" value="{{status.id}}">{{status.name}}</option>
                         </select>
                     </div>
                 </div>
                 <div class="col-md-4">
                     <div class="form-group">
                         <label>Percentage Done</label>
                         <input type="number" class="form-control form-control-sm" formControlName="percent_done">
                     </div>
                 </div>
             </div>
             
             <div class="row pt-0">
                 <div class="col-md-4">
                     <div class="form-group">
                         <label class="form-check form-check-inline">
                             <input type="checkbox" class="form-check-input radio-dark-gray" formControlName="is_urgent" ng-true-value="1" ng-false-value="0">
                             <span class="form-check-label">Is Urgent</span>
                         </label>
                     </div>
                 </div>
                  <div class="col-md-8">
                     <div class="form-group">
                         <label>Notes</label>
                         <textarea class="form-control form-control-sm" formControlName="notes" rows="2" cols="50"></textarea>
                     </div>
                 </div>
             </div>
             <div class="row pt-0">
                 <div class="col-md-6">
                     <div class="form-group" *ngIf ="(fileExists==true)">
                         <label class="form-control-label">File:</label><br/>
                         <label>{{task?.file}}</label> <button class="btn btn-sm btn-primary" type="button" (click)="removeFile()">Remove File</button>
                     </div>
                     <div class="form-group" *ngIf ="(fileExists==false)">
                         <label class="text-gray">File :</label>
                         <app-image-uploader (passImage)="getFile($event)"></app-image-uploader>
                     </div>
                     <small><i>*Note: Allowed files are *.pdf, image files (*png,*.jpg,*.gif).</i></small>
                 </div>
             </div>
        
    </div>
    
    <div class="modal-footer">
        <small class="mr-auto"><i> Note: <span class="text-danger">*</span> = required</i></small>
        <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
        <button *ngIf="isEditMode==false" type="submit" class="btn btn-sm btn-success" [disabled]="!frmTask.valid || spinner == true">Save</button>
        <button *ngIf="isEditMode==true" type="submit" class="btn btn-sm btn-success" [disabled]="!frmTask.valid || spinner == true">Save Changes</button>
        <button type="button" class="btn btn-sm btn-secondary" (click)="close()" ngbAutofocus>Cancel</button>
    </div>
    </form>
    <!-- END OF MODAL ADD TASK FORM -->